import { Metrics } from '../_app/cuchillo/core/Metrics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Default from './Default';

export default class Contact extends Default {
  
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();
  }

  /*how__effect(__call) {
    Scroll.updateItems();

    if (this.isFirstTime) {
      Preloader.hide(() => { 
        Wrap.show(() => {
          this.showHome() 
        });
      });
      
    } else {
      Wrap.show(() => { this.showHome() });
    }
  }

  showHome() {
   // Scroll.goto(Metrics.HEIGHT * .9);
    this.afterShow()
  }*/
}

ControllerPage._addPage("contact", Contact)
